






import { StringProp } from '@/util/prop-decorators';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class OccupancyIndicator extends Vue {
  @StringProp()
  private readonly state?: string;
}
